<template>
    <v-form ref="form" class="w-100" v-if="item">
        <v-container fluid class="pa-0">
            <v-row class="no-frame">
                <v-col  >
                    <f-title :title="$t('inb.detail.head.title')" />
                    <v-row dense class="mb-5">
                        <v-col class="pa-0">
                            <c-inb-context
                                :item     = "item"
                                :readonly = "readonly"
                                @morph    = "onMorph"
                                @changed  = "onContext"
                                ref       = "siteselect"
                            />
                        </v-col>
                    </v-row>
                </v-col>

                <v-col >
                    <f-title title="Rechnung" class=" mt-0"/>
                    <inb-invoice-types
                        v-model    = "item.invoiceType"
                        category   = "invoice"
                        label      = "Rechnungsart"
                        :rules     = "[rules.requiredcombo]"
                        :readonly  = "readonly"
                        :clearable = "!readonly"
                        @change    = "onInvoiceType"
                    />

                    <f-title title="Rechnungsdaten" class="mt-5" />
                    <v-text-field
                        v-model        = "item.ordernumber"
                        label          = "Auftragsnummer"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        class          = "mt-6"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                    <v-text-field
                        v-model        = "item.invoicenumber"
                        label          = "Rechnungsnummer"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                    <f-date-picker
                        label     = "Rechnungsdatum"
                        :readonly = "readonly"
                        :time     = "false"
                        v-model   = "item.invoiceDate"
                    />

                    <f-currency-field
                        v-model   = "item.netamount"
                        :readonly = "readonly"
                        label     = "Gesamtbetrag (netto)"
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import Inb             from "@/modules/inb/service/Inb";
import FTitle          from "@/modules/core/components/utils/FTitle";
import FCurrencyField  from "@/modules/core/components/utils/FCurrencyField";
import InbInvoiceTypes from "@/modules/inb/components/controlls/InbInvoiceTypes";
import FDatePicker     from "@/modules/core/components/utils/FDatePicker";
import CInbContext     from "@/modules/inb/components/controlls/CInbContext";

export default {
    name: "CInboxInvoice",

    props: {
        item: {
            default : function () {
                return {
                    id: null,
                    netamount  : null,
                    tax        : null,
                    totalamount: null,
                    contact: {
                    company: null,
                        street : null,
                        city   : null,
                        zip    : null,
                    }
                };
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    components: {
        CInbContext,
        InbInvoiceTypes,
        FCurrencyField,
        FTitle,
        FDatePicker,
    },

    data: () => ({
    }),

    computed: {
        rules () {
            return Core.rule;
        },

        total () {
            const sum = this.item.netamount + this.item.tax;
            if (Number.isNaN(sum) === true) {
                return "";
            }

            return sum;
        },
    },

    watch: {
        total () {
            this.item.totalamount = this.total;
        }
    },

    methods: {
        onSave (success) {
            this.$refs.form.validate();
            Inb.store(this, this.item).then((data) => {
                if (this.$refs.siteselect) {
                    this.$refs.siteselect.closeMenu ();
                }

                if (success) success(data)
            });
        },

        onInvoiceType () {
            this.item.incidentType = this.item.invoiceType.incidentType;
            this.$refs.form.validate();
            Inb.store(this, this.item).then((attachment) => {
                this.$emit("context", attachment)
            });
        },

        onContext (item) {
            this.$emit("context", item)
        },

        onMorph (event) {
            this.$emit("morph", event)
        },
    }
}
</script>
